import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAuthUserStore } from '@/app/stores/user';

export const ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND';

export function isAccountNotFoundError(error: any): boolean {
  return error?.graphQLErrors?.[0]?.extensions?.classification === ACCOUNT_NOT_FOUND;
}

/**
 * Текст плейсхолдера для пустого списка счетов.
 * По умолчанию — «нет доступа к платежам», а при ошибке ACCOUNT_NOT_FOUND —
 * текст notFoundLabel того раздела, в котором вызван композабл.
 */
export const useAccountEmptyLabel = (notFoundLabel?: string) => {
  const { t } = useI18n();
  const authUserStore = useAuthUserStore();
  const isAccountNotFound = ref(false);

  const accountEmptyLabel = computed(() =>
    isAccountNotFound.value && notFoundLabel
      ? t(notFoundLabel)
      : t('ACCOUNT.EMPTY_BY_ACCESS', { company_name: authUserStore.selectedUserContract?.companyName ?? '' })
  );

  const resetAccountsError = () => {
    isAccountNotFound.value = false;
  };

  /** Возвращает true, если ошибка обработана как ACCOUNT_NOT_FOUND */
  const handleAccountsError = (error: unknown) => {
    isAccountNotFound.value = isAccountNotFoundError(error);
    return isAccountNotFound.value;
  };

  return { accountEmptyLabel, resetAccountsError, handleAccountsError };
};
